import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthStoredUserData } from './pageDataTypes';

const initialState: AuthStoredUserData = {
  loginMethod: 'none',
  email: '',
  password: '',
  // We can update this later once we have the information to determine this
  accountStatus: 'new',
  existingAccountHasBeenAuthenticated: false,
  phone: {
    country: 'us',
    countryDialCode: '1',
    phoneNumber: '',
  },
  'registration start': {
    agreedTermsOfUse: true,
    agreedPrivacyPolicy: true,
    agreed13OrOlder: true,
  },
  'enter phone': {},
  'enter confirmation code': {
    hasValidatedPhoneNumber: false,
    validatedPhoneNumber: {
      country: '',
      countryDialCode: '',
      phoneNumber: '',
    },
  },
  'enter email': {},
  'email sign in': {},
  'email sign up': {},
  'registration end': {},
};

const authReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoginMethod(
      state: AuthStoredUserData,
      action: PayloadAction<typeof initialState.loginMethod>,
    ) {
      state.loginMethod = action.payload;
    },
    setEmail(
      state: AuthStoredUserData,
      action: PayloadAction<typeof initialState.email>,
    ) {
      state.email = action.payload;
    },
    setPassword(
      state: AuthStoredUserData,
      action: PayloadAction<typeof initialState.password>,
    ) {
      state.password = action.payload;
    },
    setRegistrationStartData(
      state: AuthStoredUserData,
      action: PayloadAction<typeof initialState['registration start']>,
    ) {
      state['registration start'] = action.payload;
    },
    setPhone(
      state: AuthStoredUserData,
      action: PayloadAction<typeof initialState.phone>,
    ) {
      state.phone = action.payload;
    },
    markPhoneForValidation(
      state: AuthStoredUserData,
      action: PayloadAction<typeof initialState.phone>,
    ) {
      // If we change the phone number at all, it's no longer been validated, so flag that
      if (
        JSON.stringify(
          state['enter confirmation code'].validatedPhoneNumber,
        ) !== JSON.stringify(action.payload)
      ) {
        state['enter confirmation code'].hasValidatedPhoneNumber = false;
      }

      state['enter confirmation code'].validatedPhoneNumber = action.payload;
    },
    markConfirmedPhone(state: AuthStoredUserData) {
      state['enter confirmation code'].hasValidatedPhoneNumber = true;
    },
    reset: () => {
      return initialState;
    },
  },
});

export const {
  setLoginMethod,
  setEmail,
  setPassword,
  setRegistrationStartData,
  setPhone,
  markPhoneForValidation,
  markConfirmedPhone,
  reset,
} = authReducer.actions;
export default authReducer.reducer;
